import { Directive } from '@angular/core';

@Directive({
    selector: '[pplPopoverClose]',
    standalone: false
})
export class PplPopoverCloseDirective {
}
